import React from "react";
import { StyleguideDocument } from "tsi-common-react/src/styleguide/StyleguideDocument";

import { Context } from "@reactivated";

type IProps = {
    storybook: boolean;
    children?: React.ReactNode;
};

/**
 * Cocoon's styleguide document chrome, shared by the block and element
 * fixture templates. Mirrors the legacy _styleguide_base.html: the
 * reactivated bundle CSS/JS (renderer-injected) is the only pixel-bearing
 * chrome; fixtures render directly in the body.
 */
export const StyleguideChrome = (props: IProps): React.JSX.Element => {
    const chrome = React.useContext(Context).chrome;
    return (
        <StyleguideDocument
            storybook={props.storybook}
            htmlLang={chrome.html_lang}
            bodyId={chrome.body_id}
            legacyJsUrl={`${chrome.static_base}dist2/legacy.js`}
        >
            {props.children}
        </StyleguideDocument>
    );
};
